
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LayoutService } from './service/app.layout.service';

import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppSidebarComponent } from './app.sidebar.component';
import { Router, RouterModule } from '@angular/router';

import { StyleClassModule } from 'primeng/styleclass';
import { StorageService } from '../_services/storage.service';
import { UserProfile } from '../_models/authModel';

@Component({
  selector: 'app-topbar',
  imports: [
    FormsModule,
    RouterModule,
    AppSidebarComponent,
    AppBreadcrumbComponent,
    StyleClassModule
  ],
  standalone: true,
  templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit {
  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

  profileInitial: string = '';
  fullName: string = '';
  position: string = '';

  constructor(public layoutService: LayoutService, public el: ElementRef) { }

  storageService = inject(StorageService);
  private router = inject(Router);

  /** ออกจากระบบ — ล้าง session แล้วไปหน้า login */
  logout(): void {
    this.storageService.clean();
    void this.router.navigate(['/login']);
  }

  ngOnInit() {
    this.profilePicture();
  }

  profilePicture() {
    const user = this.storageService.getUser();
    this.fullName = user.fullName;
    this.position = user.position;
    this.profileInitial = user.fullName ? user.fullName[0].toUpperCase() : '';
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick() {
    this.layoutService.showRightMenu();
  }

  onSearchClick() {
    this.layoutService.toggleSearchBar();
  }

  onRightMenuClick() {
    this.layoutService.showRightMenu();
  }

  get logo() {
    const logo =
      this.layoutService.config().menuTheme === 'white' ||
        this.layoutService.config().menuTheme === 'orange'
        ? 'dark'
        : 'white';
    return logo;
  }
}
